<template>
    <div>
        <app-auction-navigation></app-auction-navigation>
        <div class="container">
            <app-location-navigation />
            <app-loader :loading="getLoaderStatus"
                        :color="options.color"
                        :size="options.size" />
            <app-locations-container v-for="(region, index) in getRegions()"
                                     v-if="!getLoaderStatus"
                                     :region="region"
                                     :counter="index"
                                     :key="index"/>
            <app-submit-button v-if="!getLoaderStatus" />
        </div>
    </div>
</template>

<script>
    import Navigation from './LocationsNavigation'
    import LocationsContainer from './LocationsContainer'
    import Loader from 'vue-spinner/src/ClipLoader'
    import SubmitButton from '../SubmitSearchButton'
    import AuctionNavigation from './../AuctionNavigation'
    export default {
        data() {
            return {
                options: this.$store.getters.getOptions
            }
        },
        methods: {
            getRegions() {
                return this.$store.getters.getRegions
            }
        },
        components: {
            appLoader: Loader,
            appLocationNavigation: Navigation,
            appLocationsContainer: LocationsContainer,
            appSubmitButton: SubmitButton,
            appAuctionNavigation: AuctionNavigation
        },
        mounted() {
            this.$store.dispatch('fetchAuctionsData')
        },
        computed: {
            getLoaderStatus() {
                return this.$store.getters.getLoaderStatus
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Auctions/Locations/AuctionLocations.vue